import { type } from 'os';

<script>
export default {
  name: "GPSColorStatus",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  render(createElement, context) {
    // console.log("GPSColorStatus context: ", context);
    let { column, rowValue } = context.data.attrs;
    let type = "";
    if (column === "source.connection_status") {
      switch (rowValue) {
        case "offline": {
          type = "danger";
          break;
        }
      }
    }
    return createElement(
      "el-tag",
      {
        attrs: {
          type: type
        }
      },
      rowValue
    );
  }
};
</script>
